import React, { useEffect, useState } from 'react'

export const SubjectButton = ({data, clave, updateSubject}) => {
    
    const [state, setState] = useState(`btn-${data[clave].estado}`)

    useEffect(() => {
        setState(`btn-${data[clave].estado}`)
    }, [data]) 
    

    const toggleState = () => {
        switch (state) {
            case "btn-not-regularized":
                updateSubject(clave,"regularized")
                //setState("btn-regularized");
                break;
            case "btn-regularized":
                updateSubject(clave,"approved")
                //setState("btn-approved");
                break;
            case "btn-approved":
                updateSubject(clave,"not-regularized")
                //setState("btn-not-regularized");
                break;
            default:
                break;

        }

    }

  return (
    <button onClick={toggleState} className={state}>{data[clave].nombre}</button>
  )
}
